/* ============================================
   CAVALLE & CO — Theme Scripts
   Ported from index.html for Shopify theme
   ============================================ */

(function() {
    'use strict';

    /* ============================================
       STICKY HEADER
       ============================================ */
    var header = document.getElementById('header');
    var announcementBar = document.querySelector('.announcement-bar');
    var lastScrollY = 0;
    var ticking = false;

    function updateHeader() {
        var scrollY = Math.max(0, window.scrollY);
        var barHeight = announcementBar ? announcementBar.offsetHeight : 0;

        if (scrollY > barHeight) {
            header.classList.add('header--scrolled');
            header.style.top = '0';
        } else {
            header.classList.remove('header--scrolled');
            header.style.top = Math.max(0, barHeight - scrollY) + 'px';
        }

        lastScrollY = scrollY;
        ticking = false;
    }

    function onScroll() {
        if (!ticking) {
            window.requestAnimationFrame(updateHeader);
            ticking = true;
        }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    updateHeader();

    /* ============================================
       MEGA MENU
       ============================================ */
    var megaShop = document.getElementById('mega-shop');
    var megaCollections = document.getElementById('mega-collections');
    var megaTriggers = document.querySelectorAll('.mega-menu-trigger');
    var megaTimeout = null;
    var activeMega = null;

    function getMegaMenu(triggerEl) {
        var megaId = triggerEl.getAttribute('data-mega');
        if (megaId === 'shop') return megaShop;
        if (megaId === 'collections') return megaCollections;
        return null;
    }

    function showMega(menu, trigger) {
        if (megaTimeout) clearTimeout(megaTimeout);
        if (activeMega && activeMega !== menu) {
            activeMega.classList.remove('mega-menu--active');
        }
        menu.classList.add('mega-menu--active');
        trigger.setAttribute('aria-expanded', 'true');
        header.classList.add('header--mega-open');
        document.body.style.overflow = 'hidden';
        activeMega = menu;
    }

    function hideMega() {
        megaTimeout = setTimeout(function() {
            if (activeMega) {
                activeMega.classList.remove('mega-menu--active');
                megaTriggers.forEach(function(t) {
                    t.setAttribute('aria-expanded', 'false');
                });
                header.classList.remove('header--mega-open');
                document.body.style.overflow = '';
                activeMega = null;
            }
        }, 200);
    }

    megaTriggers.forEach(function(trigger) {
        trigger.addEventListener('mouseenter', function() {
            var menu = getMegaMenu(trigger);
            if (menu) showMega(menu, trigger);
        });

        trigger.addEventListener('mouseleave', function() {
            hideMega();
        });

        trigger.addEventListener('focus', function() {
            var menu = getMegaMenu(trigger);
            if (menu) showMega(menu, trigger);
        });
    });

    [megaShop, megaCollections].forEach(function(menu) {
        if (!menu) return;
        menu.addEventListener('mouseenter', function() {
            if (megaTimeout) clearTimeout(megaTimeout);
        });
        menu.addEventListener('mouseleave', function() {
            hideMega();
        });
    });

    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && activeMega) {
            activeMega.classList.remove('mega-menu--active');
            megaTriggers.forEach(function(t) {
                t.setAttribute('aria-expanded', 'false');
            });
            header.classList.remove('header--mega-open');
            document.body.style.overflow = '';
            activeMega = null;
        }
    });

    /* ============================================
       MOBILE NAVIGATION
       ============================================ */
    var hamburger = document.getElementById('hamburger');
    var mobileNav = document.getElementById('mobile-nav');
    var mobileNavOverlay = document.getElementById('mobile-nav-overlay');
    var mobileNavClose = document.getElementById('mobile-nav-close');
    var previouslyFocused = null;

    function openMobileNav() {
        previouslyFocused = document.activeElement;
        hamburger.classList.add('active');
        hamburger.setAttribute('aria-expanded', 'true');
        mobileNav.classList.add('active');
        mobileNavOverlay.classList.add('active');
        mobileNavOverlay.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';

        // Focus first link
        var firstLink = mobileNav.querySelector('a');
        if (firstLink) firstLink.focus();
    }

    function closeMobileNav() {
        hamburger.classList.remove('active');
        hamburger.setAttribute('aria-expanded', 'false');
        mobileNav.classList.remove('active');
        mobileNavOverlay.classList.remove('active');
        mobileNavOverlay.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';

        if (previouslyFocused) previouslyFocused.focus();
    }

    hamburger.addEventListener('click', function() {
        if (mobileNav.classList.contains('active')) {
            closeMobileNav();
        } else {
            openMobileNav();
        }
    });

    mobileNavClose.addEventListener('click', closeMobileNav);
    mobileNavOverlay.addEventListener('click', closeMobileNav);

    // Close mobile nav on Escape
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && mobileNav.classList.contains('active')) {
            closeMobileNav();
        }
    });

    // Trap focus inside mobile nav
    mobileNav.addEventListener('keydown', function(e) {
        if (e.key !== 'Tab') return;
        var focusables = mobileNav.querySelectorAll('a, button, [tabindex]:not([tabindex="-1"])');
        if (focusables.length === 0) return;
        var first = focusables[0];
        var last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
        }
    });

    /* ============================================
       CART DRAWER
       ============================================ */
    var cartBtn = document.getElementById('cart-btn');
    var cartDrawer = document.getElementById('cart-drawer');
    var cartOverlay = document.getElementById('cart-overlay');
    var cartClose = document.getElementById('cart-close');
    var cartShopBtn = document.getElementById('cart-shop-btn');

    function openCart() {
        cartDrawer.classList.add('active');
        cartOverlay.classList.add('active');
        cartOverlay.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        cartClose.focus();
        fetch('/cart.js').then(function(r) { return r.json(); }).then(renderCartDrawer);
    }

    function closeCart() {
        cartDrawer.classList.remove('active');
        cartOverlay.classList.remove('active');
        cartOverlay.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        cartBtn.focus();
    }

    /* The cart icon always goes to the full cart page.
       The drawer is only for confirming something was just added. */
    cartBtn.addEventListener('click', function() {
        window.location.href = '/cart';
    });
    cartClose.addEventListener('click', closeCart);
    cartOverlay.addEventListener('click', closeCart);
    if (cartShopBtn) {
        cartShopBtn.addEventListener('click', function(e) {
            e.preventDefault();
            closeCart();
        });
    }

    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && cartDrawer.classList.contains('active')) {
            closeCart();
        }
    });

    // Trap focus in cart
    cartDrawer.addEventListener('keydown', function(e) {
        if (e.key !== 'Tab') return;
        var focusables = cartDrawer.querySelectorAll('a, button, [tabindex]:not([tabindex="-1"])');
        if (focusables.length === 0) return;
        var first = focusables[0];
        var last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
        }
    });

    /* ============================================
       SEARCH OVERLAY
       ============================================ */
    var searchBtn = document.getElementById('search-btn');
    var searchOverlay = document.getElementById('search-overlay');
    var searchClose = document.getElementById('search-close');
    var searchInput = document.getElementById('search-input');

    function openSearch() {
        searchOverlay.classList.add('active');
        document.body.style.overflow = 'hidden';
        setTimeout(function() {
            searchInput.focus();
        }, 100);
    }

    function closeSearch() {
        searchOverlay.classList.remove('active');
        document.body.style.overflow = '';
        searchBtn.focus();
    }

    searchBtn.addEventListener('click', openSearch);
    searchClose.addEventListener('click', closeSearch);

    searchOverlay.addEventListener('click', function(e) {
        if (e.target === searchOverlay) closeSearch();
    });

    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && searchOverlay.classList.contains('active')) {
            closeSearch();
        }
    });

    /* ============================================
       SCROLL REVEAL (IntersectionObserver)
       ============================================ */
    var revealEls = document.querySelectorAll('.reveal');

    if ('IntersectionObserver' in window) {
        var revealObserver = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    entry.target.classList.add('reveal--visible');
                    revealObserver.unobserve(entry.target);
                }
            });
        }, {
            threshold: 0.12,
            rootMargin: '0px 0px -40px 0px'
        });

        revealEls.forEach(function(el) {
            revealObserver.observe(el);
        });
    } else {
        // Fallback: show all
        revealEls.forEach(function(el) {
            el.classList.add('reveal--visible');
        });
    }

    /* ============================================
       LAZY LOAD IMAGES
       ============================================ */
    if ('IntersectionObserver' in window) {
        var imgObserver = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    var img = entry.target;
                    if (img.dataset.src) {
                        img.src = img.dataset.src;
                        img.removeAttribute('data-src');
                    }
                    imgObserver.unobserve(img);
                }
            });
        }, {
            rootMargin: '200px'
        });

        document.querySelectorAll('img[data-src]').forEach(function(img) {
            imgObserver.observe(img);
        });
    }

    /* ============================================
       SMOOTH SCROLL FOR ANCHOR LINKS
       ============================================ */
    document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
        anchor.addEventListener('click', function(e) {
            var href = this.getAttribute('href');
            if (href === '#' || href === '#book') return;

            var target = document.querySelector(href);
            if (target) {
                e.preventDefault();
                var offsetTop = target.getBoundingClientRect().top + window.scrollY - 120;
                window.scrollTo({
                    top: offsetTop,
                    behavior: 'smooth'
                });

                // Close mobile nav if open
                if (mobileNav.classList.contains('active')) {
                    closeMobileNav();
                }
            }
        });
    });

    /* ============================================
       CATEGORY CARD KEYBOARD ACCESS
       ============================================ */
    document.querySelectorAll('.category-card[role="link"]').forEach(function(card) {
        card.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                // Simulate click
                card.click();
            }
        });
    });

    /* ============================================
       NEWSLETTER FORM
       ============================================ */
    var newsletterForm = document.querySelector('.newsletter__form');
    if (newsletterForm) {
        newsletterForm.addEventListener('submit', function(e) {
            e.preventDefault();
            var emailInput = document.getElementById('newsletter-email');
            var email = emailInput.value.trim();

            if (email) {
                var formData = new FormData(newsletterForm);
                fetch(newsletterForm.action, {
                    method: 'POST',
                    body: formData,
                    headers: { 'Accept': 'application/json' }
                }).then(function() {
                    var formParent = newsletterForm.parentNode;
                    newsletterForm.style.display = 'none';

                    var successMsg = document.createElement('div');
                    successMsg.style.cssText = 'padding: 20px; border: 1px solid rgba(197,165,90,0.3); margin: 0 auto; max-width: 480px;';
                    successMsg.innerHTML = '<p style="font-family: var(--font-heading); font-size: 20px; color: var(--warm-cream); margin-bottom: 8px;">Welcome to the CAVALLE &amp; CO World</p><p style="font-family: var(--font-body); font-size: 13px; font-weight: 300; color: rgba(250,247,242,0.7);">Thank you for subscribing. Check your inbox for your exclusive 10% off code.</p>';
                    formParent.insertBefore(successMsg, newsletterForm.nextSibling);

                    var privacyNote = document.querySelector('.newsletter__privacy');
                    if (privacyNote) privacyNote.style.display = 'none';
                });
            }
        });
    }

    /* ============================================
       PARALLAX EFFECT (subtle)
       ============================================ */
    var parallaxSection = document.querySelector('.parallax-section');
    if (parallaxSection && window.matchMedia('(min-width: 769px)').matches) {
        window.addEventListener('scroll', function() {
            var rect = parallaxSection.getBoundingClientRect();
            var viewHeight = window.innerHeight;
            if (rect.top < viewHeight && rect.bottom > 0) {
                var scrollPercent = (viewHeight - rect.top) / (viewHeight + rect.height);
                var yOffset = (scrollPercent - 0.5) * 40;
                parallaxSection.style.backgroundPositionY = 'calc(50% + ' + yOffset + 'px)';
            }
        }, { passive: true });
    }

    /* ============================================
       HERO SCROLL CTA
       ============================================ */
    var heroScroll = document.querySelector('.hero__scroll');
    if (heroScroll) {
        heroScroll.addEventListener('click', function() {
            var firstSection = document.querySelector('.hero + .section, .hero + section');
            if (firstSection) {
                var offsetTop = firstSection.getBoundingClientRect().top + window.scrollY - 100;
                window.scrollTo({
                    top: offsetTop,
                    behavior: 'smooth'
                });
            }
        });
        heroScroll.style.cursor = 'pointer';
    }

    /* ============================================
       DYNAMIC CART DRAWER
       ============================================ */
    function formatMoney(cents) {
        return '$' + (cents / 100).toFixed(2);
    }

    function escapeHtml(str) {
        var div = document.createElement('div');
        div.textContent = str;
        return div.innerHTML;
    }

    function updateCartCount(count) {
        document.querySelectorAll('.cart-count').forEach(function(el) { el.textContent = count; });
        var headerCount = document.getElementById('cart-header-count');
        if (headerCount) headerCount.textContent = count;
    }

    /* Variant line for the bag: show the colour as a dot, not just its name.
       Hexes come from window.CAVALLE_SWATCHES, rendered by the theme from
       Shopify's colour metaobjects. */
    function swatchHex(value) {
        var map = window.CAVALLE_SWATCHES || {};
        if (map[value]) return map[value];
        var keys = Object.keys(map);
        for (var i = 0; i < keys.length; i++) {
            if (keys[i].toLowerCase() === String(value).toLowerCase()) return map[keys[i]];
        }
        // compound names like "Cream/Black" fall back to the first colour
        var first = String(value).split('/')[0].trim();
        for (var j = 0; j < keys.length; j++) {
            if (keys[j].toLowerCase() === first.toLowerCase()) return map[keys[j]];
        }
        return null;
    }

    function renderVariantLine(item) {
        var parts = [];
        if (item.options_with_values && item.options_with_values.length) {
            parts = item.options_with_values.map(function(o) { return { name: o.name, value: o.value }; });
        } else {
            parts = String(item.variant_title).split(' / ').map(function(v) { return { name: '', value: v }; });
        }
        return parts.map(function(o) {
            var hex = /colour|color/i.test(o.name || '') ? swatchHex(o.value) : swatchHex(o.value);
            if (hex) {
                return '<span class="cart-swatch" style="background-color:' + escapeHtml(hex) + '" title="' +
                       escapeHtml(o.value) + '"></span>' + escapeHtml(o.value);
            }
            return escapeHtml(o.value);
        }).join('<span class="cart-variant-sep">/</span>');
    }

    /* ---- Line item imagery ----------------------------------------
       Shopify hands back whichever image happens to be attached to the
       variant, which on this catalogue is often a cropped detail shot.
       Zac's rule: show the first image that matches the colour, and fall
       back to the product's FIRST image, never a stray variant crop. */
    var productCache = {};

    function lineColour(item) {
        var opts = item.options_with_values || [];
        for (var i = 0; i < opts.length; i++) {
            var n = (opts[i].name || '').toLowerCase();
            if (n === 'colour' || n === 'color') return opts[i].value;
        }
        return null;
    }

    function loadProduct(handle) {
        if (productCache[handle]) return productCache[handle];
        productCache[handle] = fetch('/products/' + handle + '.js')
            .then(function(r) { return r.json(); })
            .catch(function() { return null; });
        return productCache[handle];
    }

    /* The hero shot (images[0]) is photographed in the option's LEAD colour,
       so for that colour it is both the first image and a correct colour
       match. Any other colour gets the first gallery-order image attached to
       it. Falls back to the hero. Verified against the Metallic and Denim
       Jean Jacket, where Shopify's own variant image is a cropped detail. */
    function preferredImage(product, colour) {
        if (!product || !product.images || !product.images.length) return null;
        var hero = product.images[0];
        if (!colour) return hero;

        var opts = product.options || [];
        var idx = -1;
        for (var i = 0; i < opts.length; i++) {
            var name = (typeof opts[i] === 'string' ? opts[i] : opts[i].name || '').toLowerCase();
            if (name === 'colour' || name === 'color') { idx = i; break; }
        }
        if (idx === -1) return hero;

        var values = (typeof opts[idx] === 'string') ? null : opts[idx].values;
        if (values && values.length && String(values[0]) === colour) return hero;

        /* product.images are protocol-relative (//cdn...) while variant
           featured_image.src is absolute (https://cdn...), so both sides have
           to be normalised or nothing ever matches. */
        function key(u) { return u.replace(/^https?:/, '').split('?')[0]; }

        var matching = {};
        product.variants.forEach(function(v) {
            if (v.options[idx] === colour && v.featured_image && v.featured_image.src) {
                matching[key(v.featured_image.src)] = true;
            }
        });
        for (var j = 0; j < product.images.length; j++) {
            if (matching[key(product.images[j])]) return product.images[j];
        }
        return hero;
    }

    function fixLineImages(scope) {
        (scope || document).querySelectorAll('img[data-line-image]').forEach(function(img) {
            var handle = img.getAttribute('data-line-image');
            if (!handle || img.getAttribute('data-resolved') === 'true') return;
            img.setAttribute('data-resolved', 'true');
            loadProduct(handle).then(function(product) {
                var src = preferredImage(product, img.getAttribute('data-colour'));
                if (src) img.src = src.replace(/(\.[^.?]+)(\?|$)/, '_120x$1$2');
            });
        });
    }

    function renderCartDrawer(cart) {
        var emptyEl = document.getElementById('cart-empty');
        var itemsEl = document.getElementById('cart-items');
        var subtotalEl = document.getElementById('cart-subtotal');
        var subtotalAmount = document.getElementById('cart-subtotal-amount');

        if (!emptyEl || !itemsEl) return;

        updateCartCount(cart.item_count);

        if (cart.item_count === 0) {
            emptyEl.style.display = '';
            itemsEl.style.display = 'none';
            if (subtotalEl) subtotalEl.style.display = 'none';
            clearUpsell();
            return;
        }

        emptyEl.style.display = 'none';
        itemsEl.style.display = '';
        if (subtotalEl) subtotalEl.style.display = '';
        if (subtotalAmount) subtotalAmount.textContent = formatMoney(cart.total_price);

        var html = '';
        cart.items.forEach(function(item) {
            html += '<div class="cart-drawer__item" data-key="' + item.key + '">';
            html += '<div class="cart-drawer__item-image">';
            var seed = (item.featured_image && item.featured_image.url) || item.image;
            if (seed) {
                html += '<img data-line-image="' + escapeHtml(item.handle || '') + '" data-colour="' + escapeHtml(lineColour(item) || '') + '" src="' + seed.replace(/(\.[^.]+)$/, '_120x$1') + '" alt="' + escapeHtml(item.product_title) + '">';
            }
            html += '</div>';
            html += '<div class="cart-drawer__item-details">';
            html += '<p class="cart-drawer__item-title">' + escapeHtml(item.product_title) + '</p>';
            if (item.properties && item.properties._pre_order === 'true') {
                html += '<span class="cart-page__preorder-badge">Pre-Order</span>';
            }
            if (item.variant_title) {
                html += '<p class="cart-drawer__item-variant">' + renderVariantLine(item) + '</p>';
            }
            html += '<p class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</p>';
            html += '<div class="cart-drawer__item-qty">';
            html += '<button class="cart-qty-btn" data-action="minus" data-key="' + item.key + '" aria-label="Decrease quantity">−</button>';
            html += '<span class="cart-qty-value">' + item.quantity + '</span>';
            html += '<button class="cart-qty-btn" data-action="plus" data-key="' + item.key + '" aria-label="Increase quantity">+</button>';
            html += '</div>';
            html += '</div>';
            html += '<button class="cart-drawer__item-remove" data-key="' + item.key + '" aria-label="Remove ' + escapeHtml(item.product_title) + '">×</button>';
            html += '</div>';
        });
        itemsEl.innerHTML = html;
        fixLineImages(itemsEl);
        refreshUpsell();
    }

    function updateCartItem(key, quantity) {
        fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: quantity })
        })
        .then(function(r) { return r.json(); })
        .then(renderCartDrawer);
    }

    document.addEventListener('click', function(e) {
        var qtyBtn = e.target.closest('.cart-qty-btn');
        if (qtyBtn) {
            e.preventDefault();
            var key = qtyBtn.getAttribute('data-key');
            var action = qtyBtn.getAttribute('data-action');
            var valueEl = qtyBtn.parentNode.querySelector('.cart-qty-value');
            var currentQty = parseInt(valueEl.textContent, 10);
            var newQty = action === 'plus' ? currentQty + 1 : Math.max(0, currentQty - 1);
            updateCartItem(key, newQty);
            return;
        }

        var removeBtn = e.target.closest('.cart-drawer__item-remove');
        if (removeBtn) {
            e.preventDefault();
            var removeKey = removeBtn.getAttribute('data-key');
            updateCartItem(removeKey, 0);
        }
    });

    /* ============================================
       CART UPSELLS
       The strip is rendered by sections/cavalle-cart-upsell.liquid and
       pulled in through the Section Rendering API, so the drawer and the
       cart page can never show different rules.
       ============================================ */
    /* The cart page is a JSON template, so the section's real id is
       template--<id>__cavalle-cart-upsell and it changes if the template is
       ever recreated. Reading /cart and lifting [data-cart-upsell] out of it
       is id-independent, so this cannot silently break later. */
    function upsellMount() {
        return document.getElementById('cart-upsell-mount');
    }

    function clearUpsell() {
        var mount = upsellMount();
        if (mount) mount.innerHTML = '';
    }

    var upsellPending = false;

    function refreshUpsell() {
        var mount = upsellMount();
        if (!mount || upsellPending) return;
        upsellPending = true;
        fetch('/cart', { headers: { 'Accept': 'text/html' } })
            .then(function(r) { return r.text(); })
            .then(function(markup) {
                var doc = new DOMParser().parseFromString(markup, 'text/html');
                var strip = doc.querySelector('[data-cart-upsell]');
                mount.innerHTML = strip ? strip.outerHTML : '';
            })
            .catch(function() { mount.innerHTML = ''; })
            .then(function() { upsellPending = false; });
    }

    /* Keep the shown price honest when a variant is picked. */
    document.addEventListener('change', function(e) {
        var sel = e.target.closest ? e.target.closest('.cart-upsell__variant') : null;
        if (!sel) return;
        var card = sel.closest('.cart-upsell__card');
        if (!card) return;
        var opt = sel.options[sel.selectedIndex];
        var btn = card.querySelector('[data-upsell-add]');
        /* target the amount span, not the whole price row: it also holds the
           compare-at strike and the free-shipping flag */
        var amountEl = card.querySelector('.cart-upsell__amount');
        if (btn) btn.setAttribute('data-variant-id', opt.value);
        if (amountEl && opt.getAttribute('data-price')) {
            amountEl.textContent = formatMoney(parseInt(opt.getAttribute('data-price'), 10));
        }
    });

    document.addEventListener('click', function(e) {
        var addBtn = e.target.closest('[data-upsell-add]');
        if (!addBtn || addBtn.disabled) return;
        e.preventDefault();

        var variantId = parseInt(addBtn.getAttribute('data-variant-id'), 10);
        if (!variantId) return;

        /* The drawer repaints itself; the cart page must reload. The drawer is
           rendered on every page, so decide by where the card actually sits. */
        var inDrawer = !!addBtn.closest('#cart-upsell-mount');

        var label = addBtn.textContent;
        addBtn.disabled = true;
        addBtn.textContent = 'Adding';

        fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        })
        .then(function(r) { return r.json(); })
        .then(function(res) {
            if (res && res.status) { throw new Error(res.description || 'Could not add'); }
            addBtn.textContent = 'Added';
            /* On the cart page, reload so the line items, totals and the
               free-shipping bar all agree with what was just added. */
            if (!inDrawer) { window.location.reload(); return; }
            return fetch('/cart.js')
                .then(function(r) { return r.json(); })
                .then(function(cart) {
                    renderCartDrawer(cart);
                    document.dispatchEvent(new CustomEvent('cart:updated'));
                });
        })
        .catch(function() {
            addBtn.disabled = false;
            addBtn.textContent = label;
        });
    });

    /* ============================================
       AJAX ADD TO CART (PDP)
       ============================================ */
    var pdpForm = document.querySelector('form[action="/cart/add"]');
    if (pdpForm) {
        pdpForm.addEventListener('submit', function(e) {
            e.preventDefault();
            var formData = new FormData(pdpForm);
            var data = {};
            formData.forEach(function(value, key) { data[key] = value; });

            var itemPayload = { id: parseInt(data.id, 10), quantity: parseInt(data.quantity, 10) || 1 };
            if (data['properties[_pre_order]']) {
                itemPayload.properties = { _pre_order: data['properties[_pre_order]'] };
            }
            fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: [itemPayload] })
            })
            .then(function(r) { return r.json(); })
            .then(function() {
                openCart();
            });
        });
    }

    /* ============================================
       PRODUCT CARD CALL TO ACTION
       Only single-variant cards add straight to the bag. Anything with a
       choice to make is a link to the product page, so the button copy
       always matches what the button does.
       ============================================ */
    document.addEventListener('click', function(e) {
        var addBtn = e.target.closest('[data-card-add]');
        if (!addBtn || addBtn.disabled) return;
        e.preventDefault();

        var label = addBtn.textContent;
        addBtn.disabled = true;
        addBtn.textContent = 'Adding';

        fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(addBtn.getAttribute('data-variant-id'), 10), quantity: 1 }] })
        })
        .then(function(r) { return r.json(); })
        .then(function(res) {
            if (res && res.status) { throw new Error(res.description || 'Could not add'); }
            addBtn.textContent = 'Added';
            openCart();
            setTimeout(function() { addBtn.disabled = false; addBtn.textContent = label; }, 1800);
        })
        .catch(function() {
            addBtn.disabled = false;
            addBtn.textContent = label;
        });
    });

})();
